import { Component, OnInit, ViewChild, ComponentFactoryResolver, ApplicationRef, Injector, OnDestroy } from '@angular/core';
import { CdkPortal, DomPortalHost } from '@angular/cdk/portal';

@Component({
  selector: 'second-screen',
  templateUrl: './second-screen.component.html',
  styleUrls: ['./second-screen.component.scss']
})
export class SecondScreenComponent implements OnInit, OnDestroy {

  @ViewChild(CdkPortal, {static: true}) private portal: CdkPortal;

   static _secondScreen: Window = null; // tbd-second-screen private
  private static _isShown: boolean = false;

  static toggleShown() {
    SecondScreenComponent._isShown = !SecondScreenComponent._isShown;
  }

  static isShown(): boolean {
    return SecondScreenComponent._isShown;
  }

  constructor(private componentFactroryResolver: ComponentFactoryResolver,
              private applicationRef: ApplicationRef,
              private injector: Injector) {
  }

  ngOnInit(): void {
    let screenWidth = window.screen.width;
    console.info('Main screen:', window.screen);

    // tbd-second-screen
    // SecondScreenComponent._secondScreen = window.open(`http://localhost:4200/#/second`, `EURON-Secondary-Screen`, `screenX=${screenWidth},screenY=0`);
    // let secScreen = SecondScreenComponent._secondScreen.screen;
    // console.info('Second screen:',  window.screen);

    // SecondScreenComponent._secondScreen.resizeTo(secScreen.availWidth, secScreen.availHeight);

    // const host = new DomPortalHost(
    //   SecondScreenComponent._secondScreen.document.body,
    //   this.componentFactroryResolver,
    //   this.applicationRef,
    //   this.injector
    // );

    // host.attach(this.portal);

    // SecondScreenComponent._secondScreen.addEventListener('unload', this.onUnload.bind(this));
    // window.addEventListener('unload', this.onUnload.bind(this));
  }

  private onUnload() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    if (SecondScreenComponent._secondScreen) {
      SecondScreenComponent._secondScreen.close();
      SecondScreenComponent._secondScreen = null;
      SecondScreenComponent._isShown = false;
      console.info('Second screen closed');
    }
  }
}
